export default __webpack_public_path__ + "static/media/copy.8754f7db.svg";